import React from 'react'
import {Text, View } from '@react-pdf/renderer'
import {Title} from './common'
import styles from './styles'

function Indicator(props) {
  return (
    <View style={styles.indicator} wrap={false}>
      <Text style={styles.indicatorName}>
        <Text style={styles.indicatorCode}>{props.code}{'\n'}</Text>
        {props.description}
      </Text>
    </View>
  )
}

function Expectation(props) {
  return (
    <View style={styles.expectation}>
      <Text style={styles.expectationTitle}>{props.name || props.description}</Text>
      {props.indicators && props.indicators.length > 0 && (
        <View style={styles.indicators}>
          {props.indicators.map(indicator => <Indicator key={indicator.id} {...indicator} />)}
        </View>
      )}
    </View>
  )
}

function Standard(props) {
  return (
    <View style={[styles.info, styles.standard]}>
      <Text style={styles.standardLabel}>{props.name}</Text>
      <View style={styles.expectations}>
        {props.expectations.map(expectation => <Expectation key={expectation.id} {...expectation} />)}
      </View>
    </View>)
}

export default function Standards (plan) {
  return (
    <React.Fragment>
      <Title title={plan.translate('planning-pdf-standards-title')} />
      <View style={styles.standards} wrap>
        {plan.groupedStandards.map(edition => (
          <View key={edition.id} style={styles.editionGroup}>
            <Text style={styles.editionHeading}>{plan.translate('standards')} · {edition.year}</Text>
            {edition.standards.map(standard => <Standard key={`${edition.id}:${standard.id}`} {...standard} />)}
          </View>
        ))}
      </View>
   </React.Fragment>)
}
